import React, { Component } from 'react';
import ReactDOM from 'react-dom'

class PostalCodeAreaForm extends Component {
  state = {
    placeholderFirst: '例）924',
    placeholderSecond: '例）0000',
  };

  convertToHalf = str => {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248));
  }

  handleChangeFirst = event => {
    const convertedValue = this.convertToHalf(event.target.value);
    const value = convertedValue.replace(/[^0-9]/, '');
    this.props.handleValueFirst(value);
    if (value.length === 3) {
      const postalCode = value + '-' + this.props.postalValueSecond;
      if(postalCode.length === 8) {
        this.props.handleCode && this.props.handleCode(postalCode);
        const input = ReactDOM.findDOMNode(this.refs.inputFirst);
        input && input.blur();
      } else {
        const input = ReactDOM.findDOMNode(this.refs.inputSecond);
        input && input.focus();
      }
    };
  }

  handleChangeSecond = event => {
    const convertedValue = this.convertToHalf(event.target.value);
    const value = convertedValue.replace(/[^0-9]/, '');
    this.props.handleValueSecond(value);
    if (value.length === 4) {
      const postalCode = this.props.postalValueFirst + '-' + value;
      if(postalCode.length === 8) {
        this.props.handleCode && this.props.handleCode(postalCode);
      }
      const input = ReactDOM.findDOMNode(this.refs.inputSecond);
      input && input.blur();
    };
  }
  render() {
    const icon = '〒';
    const dashBar = '-';

    return (
      <div
        className="PostalCodeAreaForm"
      >
        <div className="PostalCodeAreaIcon" >
          {icon}
        </div>
        <form  >
          <input
            ref="inputFirst"
            className="PostalCodeInput First"
            type="tel"
            maxLength={3}
            value={this.props.postalValueFirst}
            onChange={this.handleChangeFirst}
            placeholder={this.state.placeholderFirst}
          />
        </form>
        <div className="PostalCodeAreaDashBar" >
          {dashBar}
        </div>
        <form  >
          <input
            ref="inputSecond"
            className="PostalCodeInput Second"
            type="tel"
            maxLength={4}
            value={this.props.postalValueSecond}
            onChange={this.handleChangeSecond}
            placeholder={this.state.placeholderSecond}
          />
        </form>
      </div>
    );
  }
};

export default PostalCodeAreaForm;
